module.exports = __webpack_public_path__ + "static/media/facebook.07b68afa.svg";